export enum PhoneSystemAppsListEnum {
  Calls = 0,
  Messages = 1,
  Settings = 2,
  Contacts = 3,
}
